export default {
  home: {
    hero: {
      badge: 'Independent Resource Hub',
      title: 'USFans Spreadsheet — The Complete Resource Hub',
      subtitle: 'Find USFans spreadsheet resources, reviews, shipping information, coupons, comparisons and practical guides — all organized in one place.',
      ctaMain: 'usfans spreadsheet',
      ctaBuy: 'buy it now',
      ctaGuide: 'Read the Complete Guide',
      trust: 'Independent Resource • Updated Guides • Multilingual • Safety-Focused',
    },
    what: {
      title: 'What Is the USFans Spreadsheet?',
      p1: 'The USFans Spreadsheet is a curated, category-based directory of US-themed merchandise. It organizes popular product types — from footwear and headwear to accessories and fragrances — into a simple, browsable structure so you always know exactly where to look.',
      p2: 'Instead of opening dozens of tabs or guessing where a product lives, you can jump straight to the matching collection through a single, clear link. It is designed to reduce friction and help fans and shoppers find what they want faster.',
    },
    categories: {
      title: 'Browse Popular Categories',
      subtitle: 'Choose a category below to jump straight to the matching collection on our main website.',
      dropdownLabel: 'Select a category',
      dropdownPlaceholder: 'Choose a category...',
      gridCta: 'Explore',
    },
    why: {
      title: 'Why Use the USFans Spreadsheet?',
      f1title: 'Clear Organization',
      f1text: 'Every product type is grouped into a simple, predictable category — no clutter, no guesswork.',
      f2title: 'Fast Access',
      f2text: 'Direct links take you to the exact collection in one click, skipping endless searching and filtering.',
      f3title: 'Always Current',
      f3text: 'The resource is maintained and updated so the categories and guides stay useful over time.',
      f4title: 'Built for Fans',
      f4text: 'From jerseys to accessories, the structure reflects what fans and shoppers actually look for.',
    },
    guide: {
      title: 'Featured Guide',
      cardTitle: 'USFans Spreadsheet: The Complete Guide',
      cardDesc: 'Learn what the spreadsheet is, what you can find inside it, how to use it, and get practical tips — plus a handy comparison table and FAQ.',
      cardCta: 'Read the Guide',
      cardDate: 'Updated regularly',
    },
    articles: {
      title: 'Pillar Guides & Articles',
      subtitle: 'In-depth guides on the USFans spreadsheet, reviews, shipping, coupons, safety and more.',
      readMore: 'Read article',
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'What is the USFans Spreadsheet?',
      a1: 'It is a category-based directory that organizes popular US fan merchandise and apparel into a simple, browsable structure with direct links to each collection.',
      q2: 'How do I use the category links?',
      a2: 'Pick a category from the dropdown or tap any category card. You will be taken directly to the matching collection on the main website.',
      q3: 'Is this an official USFans website?',
      a3: 'No. This is an independent informational resource that links to the main website, where the products are actually sold.',
      q4: 'Do I need to create an account to browse?',
      a4: 'No account is required. You can browse every category and read every guide completely free.',
      q5: 'How do I reach the main website?',
      a5: 'Use the "usfans spreadsheet" or "buy it now" buttons, or any category link — they all lead to the main website.',
    },
    cta: {
      title: 'Ready to Explore?',
      text: 'Browse all categories or head straight to the main website to see the full collection.',
      button: 'Visit Main Website',
      button2: 'usfans spreadsheet',
    },
  },
};